import React, { useState } from "react";
import { useDictionary } from "hooks";
import AccountDistribution from "components/AccountDistribution";
import CovertButton from "@cayuse/shared-react.components.covert-button";
import styles from "./styles.css";

const AwardAccountView = () => {
	const [ activeSection, setActiveSection ] = useState("distribution");
	const dictionary = useDictionary("awards.fundDistribution");

	return (
		<div data-component="Containers\Awards\Detail\AwardAccountView" className={styles.awardAccountView}>
			<div className={styles.navWrapper}>
				<h3 className={styles.navHeader }>Sections</h3>
				<ul className={styles.nav}>
					<li>
						<CovertButton
							className={`${styles.sectionButton} ${activeSection === "distribution" ? styles.active : ""}`}
							onClick={() => setActiveSection("distribution")}
							aria-label={`${dictionary.sectionLabel ?? "Fund & Distribution Summary"} ${activeSection === "distribution" ? "selected" : ""}`}
						>
							{dictionary.sectionLabel ?? "Fund & Distribution Summary"}
						</CovertButton>
					</li>
					{/* //TODO: build Award Burndown
						<li>
							<CovertButton
								className={`${styles.sectionButton} ${activeSection === "burndown" ? styles.active : ""}`}
								onClick={() => setActiveSection("burndown")}
								aria-label={`Award Burndown ${activeSection === "burndown" ? "selected" : ""}`}
							>
								Award Burndown
							</CovertButton>
						</li>
					*/}
				</ul>
			</div>

			<div>
				{ activeSection === "distribution" &&
					<AccountDistribution className={styles.accountDistribution}></AccountDistribution>
				}

				{ /* activeSection === "burndown" && // TODO: build Burndown component
					<span>Burndown</span>
					*/
				}
			</div>
		</div>
	);
};

export default AwardAccountView;
